import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import CandidateCard from "./CandidateCard";
import CandidateProfile from "./CandidateProfile";
import Pipeline from "./Pipeline";
import EmptyCandidates from "./EmptyCandidate";
import { PIPELINE_STEPS } from "variables/constants";
import {
    Users,
} from "lucide-react";
import Card from "components/card";
import { 
	getApplicantList
} from "../../../../redux/recruitment/recruitmentState";

const CandidateBoard = ({ recordList, pagination, doSearch, filters, doDelete, user, doSearchApplicants}) => {
    const [selected, setSelected] = useState(null);
    const [stageFilter, setStageFilter] = useState(0); 
    const [positionFilter, setPositionFilter] = useState(0);

    const stageMap = {
        1: "Application",
        2: "Screening",
        3: "Testing",
        4: "Shortlisting",
        5: "Client Endorsement",
        6: "Client Selection",
        7: "References",
        8: "Offer",
        9: "Onboarding",
    };

    const positionMap = {
        1: "Senior Software Engineer",
        2: "UX/UI Designer",
        3: "Product Manager",
        4: "Data Scientist",
        5: "DevOps Engineer",
    };

    const stagesInOrder = Object.values(stageMap);

    const getProgressByStage = (stage) => {
        const index = stagesInOrder.indexOf(stage);
        if (index === -1) return 0;
        return Math.round(((index + 1) / stagesInOrder.length) * 100);
    };

    const pipelineCounts = Object.keys(PIPELINE_STEPS).map((name) => ({
        name,
        icon: PIPELINE_STEPS[name],
        count: recordList?.filter((c) => c.stage === name).length,
    }));

    const advanceStage = (candidate) => {
        const currentIndex = stagesInOrder.indexOf(candidate.stage);
        if (currentIndex === -1) return candidate.stage;
        if (currentIndex === stagesInOrder.length - 1) return candidate.stage; 
        return stagesInOrder[currentIndex + 1];
    };

    const handleAdvanceConfirmFromProfile = () => {
        if (!selected) return;

        const updatedStage = advanceStage(selected);

        const updatedCandidates = recordList?.map((c) =>
            c.id === selected.id ? { ...c, stage: updatedStage } : c
        );

        //setCandidates(updatedCandidates);

        setSelected({ ...selected, stage: updatedStage });
    };

    useEffect(() => {
            doSearchApplicants({paginate: pagination.per_page});
        }, [doSearch, pagination.per_page]);

    return (
        <div className="flex flex-col">
            <div className="space-y-6">
                <Pipeline steps={pipelineCounts} />
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    <div className="col-span-2">
                        <Card className="flex flex-col gap-6 rounded-2xl shadow-sm bg-white border-2 border-slate-200">
                            <div className="bg-gradient-to-br from-emerald-50 to-cyan-50 border-b rounded-t-2xl p-6 grid items-start gap-1.5">
                                <div className="flex items-center justify-between gap-2">
                                    <div className="min-w-0">
                                        <h4 className="text-[18px]">
                                            Active Candidates
                                        </h4>
                                        <p className="text-[14px] text-slate-700">
                                            {recordList?.length } candidates in pipeline
                                        </p>
                                    </div>
                                    <span className="inline-flex items-center justify-center w-6 h-6 rounded-lg px-2 py-0.5 font-medium  bg-gradient-to-br from-emerald-500 to-cyan-500 text-white text-[13px] flex-shrink-0">
                                        {recordList?.length }
                                    </span>
                                </div>
                            </div>
                            <div className="pb-6 p-6 space-y-3">
                                <div className="grid grid-cols-1 gap-4 overflow-y-auto max-h-[600px]">
                                    {recordList?.length === 0 ? (
                                        <EmptyCandidates />
                                    ) : (
                                        recordList?.map((candidate) => (
                                            <CandidateCard
                                                key={candidate.id}
                                                recordData={candidate}
                                                {...candidate}
                                                progress={getProgressByStage(candidate.stage)}
                                                selected={selected?.id === candidate.id}
                                                onClick={() => setSelected(candidate)}
                                                stage={candidate.stage}
                                            />
                                        ))
                                    )}
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div className="hidden lg:block">
                        {selected ? (
                            <CandidateProfile 
                                candidate={selected} 
                                onAdvance={handleAdvanceConfirmFromProfile}
                            />
                            ) : (
                            <div className="flex flex-col items-center justify-center h-[200px] text-gray-500 text-sm bg-white border-2 rounded-xl border-slate-300 border-dashed pb-6 px-4 py-12 text-center">
                                <Users className="w-12 h-12 text-gray-800 mb-3" />
                                <h4 className="text-[14px] font-semibold mb-2">
                                    No Candidate Selected
                                </h4>
                                <p className="text-[12px] max-w-xs">
                                    Select a candidate from the list to view their details and progress
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    recordList: state.recruitment.applicantList?.items,
    pagination: state.recruitment.applicantList?.pagination,
	filters: state.recruitment.applicantList?.filters,
  	requesting: state.recruitment.applicantList?.requesting,
  	error: state.recruitment.applicantList?.error,
});

const mapDispatchToProps = (dispatch) => ({
    doSearchApplicants: (data) => dispatch(getApplicantList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CandidateBoard);